import { DictionaryInterface } from '@actassa/api';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, switchMap, take } from 'rxjs/operators';

import { DataCollectionInterface } from '../interfaces/data-collection.interface';

import { DataCollectionFacadeService } from './data-collection-facade.service';

@Injectable()
export class CreateInspectionService {
    constructor(
        private readonly dataCollectionFacadeService: DataCollectionFacadeService,
    ) { }

    public processOnce$(templateId: string, prefilledAnswers?: DictionaryInterface<string | number>): Observable<unknown> {
        return this.dataCollectionFacadeService.getDataCollectionTemplate$(templateId)
            .pipe(
                switchMap(template => this.dataCollectionFacadeService.getActiveDataCollectionByTemplateId$(template.id)
                    .pipe(
                        switchMap((existedDataCollection: DataCollectionInterface | undefined) => {
                            if (template.lookForIncomplete && existedDataCollection) {
                                return this.dataCollectionFacadeService
                                    .batchDataCollectionCreate$(existedDataCollection, existedDataCollection.autoFinish);
                            }

                            const rawDataCollection = this.dataCollectionFacadeService.buildDataCollectionFromTemplate(template);
                            const dataCollection = this.dataCollectionFacadeService
                                .preFillDataCollection(rawDataCollection, prefilledAnswers);

                            return this.dataCollectionFacadeService
                                .batchDataCollectionCreate$(dataCollection, dataCollection.autoFinish);
                        }),
                    )),
                take(1),
                catchError(error => {
                    this.dataCollectionFacadeService.showToast(error.message);

                    return of(null);
                }),
            );
    }
}
